<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button ttText="create_new_deviation" (ttClick)="goToFunc('deviation')" ttIcon="far fa-plus"></tt-button>
    </tt-card>

    <tt-list [ttData]="itemsListDeviations"></tt-list>
</tt-page>
